
import { Input, Table, InputNumber } from "antd";
import React from "react";
import Delete from "../../../assets/images/delete_icon.svg";
import Add_more from "../../../assets/images/add_more.svg";


const CostCard = (props) => {
    const { onAddNewCostRow, onDeleteCostRow, index, onCostDataChange, menuCustomizationAddons=[], field } = props;
    const columns = [
        {
            title: 'Options',
            dataIndex: 'name',
            key: 'name',
            width: '70%',
            render: (_, record, rowIndex) => {
                return <div className="applicable_list">
                    <Input placeholder="Enter Option here" name="option_name" value={record?.option_name} onChange={(e)=>onCostDataChange(index, rowIndex, e, 'option_name', field)}/>
                </div>
            }
        },
        {
            title: 'Cost',
            dataIndex: 'cost',
            key: 'cost',
            width: '15%', 
            render: (_, record, rowIndex) => {
                return <div className="applicable_list" >
                <InputNumber type="number" placeholder="$0.00" name="cost" value={record?.cost} onChange={(e)=>onCostDataChange(index, rowIndex, e, 'cost', field)} />
            </div>
            }
        },
        {
            title: 'Action',
            width: '15%', 
            render: (_, record, rowIndex) => {
                return <div className="delete_action">
                    <img src={Delete} alt="" onClick={()=> onDeleteCostRow(index, rowIndex, field)}/>
                </div>
            }
        }
    ];
    return <div>
        <Table columns={columns} bordered dataSource={[...menuCustomizationAddons]} pagination={false} className="customise-table" />
        <div className="add_costcolumn" onClick={()=> onAddNewCostRow(index, field)}>Add Option 
            <img src={Add_more} alt="" style={{ marginLeft: 5}}/>
        </div>
    </div>
};
export default CostCard;